import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Role, VendorData } from 'src/app/models/admin/admin';
import { AccountDetailService } from 'src/app/services/account/account-detail.service';
import { AccountService } from 'src/app/services/account/account.service';
import { AdminServiceService } from 'src/app/services/admin/admin-service.service';

@Component({
  selector: 'app-users-management',
  templateUrl: './users-management.component.html',
  styleUrls: ['./users-management.component.scss']
})
export class UsersManagementComponent implements OnInit {
  account = localStorage.getItem('HechRomeoAccount');
  role: Role = localStorage.getItem('HechRomeoRole') as Role | null;
  usersList: VendorData[] = [];
  vendorToDelete;
  searchValue: string;
  accountEmail: string;

  constructor(
    private readonly accountService: AccountService,
    private accountDetailService: AccountDetailService,
    private adminService: AdminServiceService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.searchValue = '';
    if (!localStorage.getItem('OriginalAccount')) {
      this.accountService.getVendorData(localStorage.getItem('HechRomeoAccount')).subscribe(res => {
        this.accountEmail = res.email;
        this.getUsersList(this.accountEmail);
      });
    } else {
      this.accountService.getOriginalVendorData().subscribe(res => {
        this.accountEmail = res.email;
        this.getUsersList(this.accountEmail);
      });
    }
  }

  getUsersList(email: string) {
    this.accountService.getLinkedUsersForManagement(email).subscribe( (vendorList :VendorData[]) => {
      this.usersList = vendorList;
    });
  }

  impersonate(vendor: VendorData) {
    if (vendor.account === localStorage.getItem('OriginalAccount')) {
      localStorage.removeItem('categoriesServices');
      localStorage.removeItem('digitalSignage');
      localStorage.removeItem('guestsManagement');
      localStorage.removeItem('tvManagement');
      localStorage.removeItem('integrations');
      localStorage.removeItem('HechRomeoVendor');

      if (this.role == "Vendor") {
        if (!localStorage.getItem('OriginalAccount')) {
          localStorage.setItem('OriginalAccount', this.account);
        }
        localStorage.setItem('HechRomeoAccount', vendor.account);
        this.accountDetailService.setAccount(vendor.account);
      }
      else {
        localStorage.setItem('HechRomeoVendor', vendor.account);
      }
      window.location.reload();

    } else {
      this.accountService.getPermissions(this.accountService.vendor, this.accountEmail).subscribe(res => {
        localStorage.setItem('categoriesServices', res.categoriesServices);
        localStorage.setItem('digitalSignage', res.digitalSignage);
        localStorage.setItem('guestsManagement', res.guestsManagement);
        localStorage.setItem('tvManagement', res.tvManagement);
        localStorage.setItem('integrations', res.integrations);
        localStorage.removeItem('HechRomeoVendor');

        if (this.role == "Vendor") {
          if (!localStorage.getItem('OriginalAccount')) {
            localStorage.setItem('OriginalAccount', this.account);
          }
          localStorage.setItem('HechRomeoAccount', vendor.account);
          this.accountDetailService.setAccount(vendor.account);
        }
        else {
          localStorage.setItem('HechRomeoVendor', vendor.account);
        }
        window.location.reload();
      }, err => {
        console.log(err);
      });
    }
    if(this.role !== 'Manager') localStorage.setItem('projecttype', vendor.projecttype || null);
  }

  deleteUser(username: string) {
    this.adminService.deleteVendor(username).subscribe(() => {
      this.getUsersList(this.accountEmail);
    });
  }

  infoUser(username: string) {
    this.cleanPermissions();
    localStorage.setItem('HechRomeoAccount', username);
    this.accountDetailService.setAccount(username);
    this.router.navigate(['accountInfo']);
  }

  cleanPermissions() {
    localStorage.removeItem('categoriesServices');
    localStorage.removeItem('digitalSignage');
    localStorage.removeItem('guestsManagement');
    localStorage.removeItem('tvManagement');
    localStorage.removeItem('integrations');
    localStorage.removeItem('HechRomeoVendor');
  }
}
